export default "__VITE_ASSET__0q1NJAB2__"